export const ACCESSIBILITY_OPTIONS_KEYS = {
  darkMode: 'dark-mode',
  increaseTextSize: 'increase-text-size',
  contrast: 'contrast',
  guideLines: 'guide-lines',
}
